import { ReactElement, useMemo } from 'react';

import { ConfidentialResource } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import {
   createDynamicColumnsWidth,
   StaticDataConfiguration,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';
import { dateTimeMinuteFormatter, practitionerNameFormatter } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../../translations';

export const useConfidentialResourcesTableColumns = (): TableColumnConfiguration<ConfidentialResource>[] => {
   return useMemo(() => {
      const columnsWidth = createDynamicColumnsWidth({
         ordinalNumber: '55px',
         date: '35%',
         owner: '65%',
      });

      return [
         {
            name: 'ordinalNumber',
            label: systemActivityTranslationKeys.ordinalNumber,
            accessor: 'owner',
            width: columnsWidth.ordinalNumber,
            renderer: (props: ValueRendererProps<ConfidentialResource>): ReactElement => (
               <>
                  {props.index + 1}
                  {'.'}
               </>
            ),
            sortingDisabled: true,
         },
         {
            name: 'creationDate',
            label: systemActivityTranslationKeys.dateAndTime,
            accessor: 'creationDate',
            width: columnsWidth.date,
            formatter: dateTimeMinuteFormatter,
            sortingDisabled: true,
         },
         {
            name: 'owner',
            label: systemActivityTranslationKeys.author,
            accessor: 'owner',
            width: columnsWidth.owner,
            formatter: practitionerNameFormatter,
            sortingDisabled: true,
         },
      ];
   }, []);
};

export const useConfidentialResourcesTableDataConfiguration = (
   resources: ConfidentialResource[]
): StaticDataConfiguration<ConfidentialResource> => {
   return useMemo(() => {
      return { data: resources };
   }, [resources]);
};
